/* eslint-disable react/sort-comp */
/* eslint-disable no-await-in-loop */
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Axios from 'axios';
import { toast } from 'react-toastify';
import ReactTelInput from 'react-telephone-input';
import OtpInput from 'react-otp-input';
import flags from '../../../icons/flags.png';
import Button from '../../../components/button/button';
import AttachmentDetail from '../../forms/components/AttachmentDetail';
import CustomFields from '../../../components/customFields/CustomFields';
import CustomFieldDetail from '../../../components/customFields/CustomFieldDetail';
import Loading from '../../../components/loading';
import styles from './publicRegistration.module.scss';
import loginStyles from '../ADP/authentication/components/login.module.scss';
import detailStyles from '../../../components/DetailPageBuilder/detail.module.scss';
import { isLocal, hostName } from '../../../constants/apiEnv';
import { GetFileName, S3Uploads } from '../../services';
import { renderInfoForType, getCountryRegion } from '../../../utils/helpers';

const status = { 12: { background: '#d0d0d0', color: '#454545', title: 'Send Back' },
  2: { background: '#F7B5001A', color: '#F7B500', title: 'Pending' },
  3: { background: '#6DD4001C', color: '#6DD400', title: 'Approved' },
  4: { background: '#F5515F22', color: '#F5515F', title: 'Rejected' } };

const tableHeadders = [
  ['first_name', 'First Name'],
  ['last_name', 'Last Name'],
  ['phone', 'Phone'],
  ['email', 'Email'],
  ['company_name', 'Company Name'],
  ['description', 'Description'],
  ['attachments', 'Attachments']
];
class CompanyRegistration extends Component {
  constructor(props) {
    super(props);
    this.state={
      step: 'login',
      defaultFields: [],
      customFields: [],
      answers: {
        response: {},
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        company_name: '',
        attachments: [],
        description: ''
      },
      formFieldsErrors: {},
      phone: '',
      otp: '',
      generateOtp: true,
      otpSent: false,
      airportLogo: '',
      formTitle: '',
      description: '',
      publicEnable: false,
      postSubmissionMsg: 'Submitted Successfully',
      loader: false,
      formErrors: false
    };
  }

  componentDidMount() {
    const { match: { params: { airportCode } } } = this.props;
    this.handleLoader(true);
    Axios.get(`${this.getPublicUrl()}/company_registration/airport_info/${airportCode}/`)
      .then((res) => {
        this.setState({ airportLogo: res.data.airport_logo,
          formTitle: res.data.form_title,
          description: res.data.description,
          publicEnable: res.data.public_enable,
          loader: false,
          postSubmissionMsg: res.data.post_submission_messag || 'Submitted Successfully ' });
      });
  }

  handleInputChange = (fieldId, answer) => {
    this.setState({ [fieldId]: answer, generateOtp: fieldId==='phone' });
  }

  handleAnswerChanged = (section, answer, fieldId) => {
    const { answers } = this.state;
    if (section === 'response') {
      this.setState({ answers: { ...answers, response: { ...answers.response, [fieldId]: answer } } });
    } else {
      this.setState({ answers: { ...answers, [fieldId]: answer } });
    }
  };

  handleFieldErrorChanged = (id, value) => {
    const { formFieldsErrors } = this.state;
    this.setState({ formFieldsErrors: { ...formFieldsErrors, [id]: value } });
  };

  getOldAndNewAttaches=(attachments) => {
    const newAttaches=[];
    const oldAttaches=[];
    attachments.forEach((e) => {
      if (e.id || (typeof e === 'string')) {
        oldAttaches.push(e.attachment_id || e);
      } else {
        newAttaches.push(e);
      }
    });
    return { newAttaches, oldAttaches };
  }

  getReplacedNumber= (phone) => {
    let registerNumber = phone.replaceAll('-', '');
        registerNumber = registerNumber.replaceAll(' ', '');
        registerNumber = registerNumber.replaceAll('(', '');
        registerNumber = registerNumber.replaceAll(')', '');
    return registerNumber;
  }

  handleSubmit = async (currentStep) => {
    const { formFieldsErrors, answers, generateOtp, phone, otpSent, otp, customFields } = this.state;
    const headers = this.getHeader();
    const { match: { params: { airportCode } } } = this.props;
    const errors = { ...formFieldsErrors };
    const noErrors = Object.keys(errors).every(k => (errors[k] === false));
    const isEmailValid =this.handleValidation(answers.email);

    if (noErrors && isEmailValid) {
      this.handleLoader(true);
    }
    let attachmentId = [];
    let defaultAttachements = {};
    if ((currentStep === 'create' || currentStep === 'edit') && noErrors && isEmailValid) {
      defaultAttachements = this.getOldAndNewAttaches(answers.attachments);
      attachmentId = await this.handleUploadAttachments(defaultAttachements.newAttaches);
      const attachmentFields = customFields.filter(schemaField => (
        (schemaField?.type === 'attachments') || schemaField?.type === 'multi_field'
      ));
      const signatureFields = customFields.filter(schemaField => (
        schemaField?.type === 'signature'
      ));
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          let custAttachments = {};
          if (schemaField?.type === 'attachments' && answers.response[attachmentField]?.length > 0) {
            custAttachments = this.getOldAndNewAttaches(answers.response[attachmentField]);
            answers.response[attachmentField] = await this.handleUploadAttachments(custAttachments.newAttaches);
            answers.response[attachmentField] = [...answers.response[attachmentField], ...custAttachments.oldAttaches];
          } else if (schemaField?.type === 'multi_field') {
            const multiAttachmentFields = schemaField?.multiple_fields
              && Object.keys(schemaField?.multiple_fields)?.filter(f => schemaField?.multiple_fields?.[f]?.type?.key === 'attachments');
            if (multiAttachmentFields?.length > 0) {
              for (let multiIndex = 0; multiIndex < multiAttachmentFields?.length; multiIndex++) {
                for (let multiDataIndex = 0; multiDataIndex < answers.response?.[schemaField?.id]?.length; multiDataIndex++) {
                  const customAttachments = answers.response?.[schemaField?.id]?.[multiDataIndex]?.[multiAttachmentFields[multiIndex]] || [];
                  if (customAttachments?.length > 0) {
                    answers.response[schemaField?.id][multiDataIndex][multiAttachmentFields[multiIndex]] = customAttachments?.map(attach => (
                      attach?.attachmentUploadId || attach?.name
                    ));
                  }
                }
              }
            }
          }
        }
      }
      if (signatureFields.length > 0) {
        for (let i = 0; i < signatureFields.length; i++) {
          const signatureField = signatureFields[i];
          if (answers.response[signatureField.id]?.[0]?.id || (typeof answers.response[signatureField.id]?.[0] === 'string')) {
            answers.response[signatureField.id] = [answers.response[signatureField.id][0].attachment_id || answers.response[signatureField.id][0]];
          } else if (answers.response[signatureField.id]) {
            answers.response[signatureField.id] = await this.handleUploadAttachments([answers.response[signatureField.id]]);
          }
        }
      }
    }
    if (currentStep === 'create') {
      if (noErrors && isEmailValid) {
        let registerNumber = this.getReplacedNumber(answers.phone);
        Axios.post(`${this.getPublicUrl()}/company_registration/register/${airportCode}/`, {
          ...answers, phone: registerNumber, attachments: [...defaultAttachements.oldAttaches, ...attachmentId]
        }, { ...headers }).then((res) => {
          this.setState({ step: 'success', formErrors: false, error: '', retrivedData: res.data.registrations, loader: false });
          toast.success('created successfully');
        }).catch((e) => {
          this.handleLoader(false);
          this.setState({ error: e.response.data.detail });
          toast.error('Please Try After Sometime');
        });
      } else {
        this.setState({ formErrors: true });
      }
    } else if (currentStep === 'edit') {
      if (noErrors && isEmailValid) {
        Axios.patch(`${this.getPublicUrl()}/company_registration/update_registration/${airportCode}/${answers.uid}/`, {
          ...answers, attachments: [...defaultAttachements.oldAttaches, ...attachmentId]
        }, { ...headers }).then((res) => {
          this.setState({ step: 'log', formErrors: false, error: '', retrivedData: res.data.registrations, loader: false });
          toast.success('updated successfully');
        }).catch((e) => {
          this.handleLoader(false);
          this.setState({ error: e.response.data.detail });
          toast.error('Please Try After Sometime');
        });
      } else {
        this.setState({ formErrors: true });
      }
    } else {
      let phonenumber = this.getReplacedNumber(phone);
      if (generateOtp) {
        Axios.post(`${this.getPublicUrl()}/company_registration/generate_otp/${airportCode}/`, { phonenumber }).then(() => {
          this.setState({ generateOtp: false, otpSent: true, loader: false });
          toast.success('otp sent successfully');
        }).catch(() => {
          this.handleLoader(false);
          toast.error('Please Try After Sometime');
        });
      }
      if (otpSent) {
        Axios.post(`${this.getPublicUrl()}/company_registration/authenticate_otp/${airportCode}/`, { phonenumber, otp }, { ...headers })
          .then((res) => {
            this.setState({ step: 'log', retrivedData: res.data.registrations, loader: false });
          })
          .catch(() => { this.handleLoader(false); toast.error('Please Try After Sometime'); });
      }
    }
  }

  getRequired = (data) => {
    let requiredKeys = {};
    data.forEach((ele) => {
      if (ele.required) {
        requiredKeys = { ...requiredKeys, [ele.id]: true };
      }
    });
    return requiredKeys;
  };

  handleCreate = () => {
    this.handleLoader(true);
    const { match: { params: { airportCode } } } = this.props;
    const headers = this.getHeader();
    Axios.get(`${this.getPublicUrl()}/company_registration/get_schema/${airportCode}`, { ...headers })
      .then((res) => {
        this.setState({ defaultFields: res.data.schema.default_fields,
          customFields: res.data.schema.fields,
          loader: false,
          formFieldsErrors: { ...this.getRequired(res.data.schema.default_fields), ...this.getRequired(res.data.schema.fields) } });
      }).catch(() => {
        this.handleLoader(false);
        toast.error('Please Try After Sometime');
      });
    this.setState({ step: 'create',
      answers: {
        response: {},
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        company_name: '',
        attachments: [],
        description: ''
      } });
  }

  handleBack = () => {
    this.setState({ step: 'log', formErrors: false });
  }

  getHeader=() => {
    const { otp, phone } = this.state;
    let phonenumber = this.getReplacedNumber(phone);
    const headers = {
      auth: {
        username: phonenumber,
        password: otp
      }
    };
    return headers;
  }

  getPublicUrl=() => {
    const { match: { params: { id } } } = this.props;
    const url = hostName.slice(6);
    const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${getCountryRegion(id)}${url}/public`;
    return publicUrl;
  }

  handleAction = (uid, step) => {
    this.handleLoader(true);
    const { match: { params: { airportCode } } } = this.props;
    const headers = this.getHeader();
    Axios.get(`${this.getPublicUrl()}/company_registration/register/${airportCode}/${uid}`, { ...headers }).then((res) => {
      this.setState({ answers: { ...res.data },
        step,
        loader: false,
        defaultFields: res.data.schema.default_fields,
        customFields: res.data.schema.schema.fields });
    }).catch(() => { this.handleLoader(false); toast.error('Please Try After Sometime'); });
  }

 fetchLocation = async () => {
   try {
     const position = await new Promise((resolve, reject) => {
       navigator.geolocation.getCurrentPosition(resolve, reject);
     });
     const response = await fetch(
       `https://maps.googleapis.com/maps/api/geocode/json?address=
        ${position.coords.latitude},
        ${position.coords.longitude}
        &key=${process.env.REACT_APP_GMAPS_KEY}`
     );
     const responseJson = await response.json();
     if (responseJson.status === 'OK') {
       const country = responseJson.results[0].address_components.find(
         component => component.types.includes('country')
       );
       if (country) {
         return (country.short_name.toLowerCase());
       }
       return 'us';
     }
     return 'us';
   } catch (error) {
     return 'us';
   }
 };

  getFileNames = async (count, code) => {
    const response = await GetFileName.getPublicUploadFileName(count, code, 'company_registration');
    return response;
  };

 doS3Upload = async (files, fileIds, entity) => {
   const { match: { params: { airportCode, id } } } = this.props;
   // eslint-disable-next-line prefer-const
   let response = await S3Uploads.uploadFiles(
     files,
     fileIds.filename,
     entity,
     id,
     airportCode
   );
   return response;
 };

 handleUploadAttachments = async (attachments) => {
   const { match: { params: { airportCode } } } = this.props;
   let fileIds = '';
   fileIds = await this.getFileNames(attachments.length, airportCode);
   const list = [];
   if (fileIds) {
     await this.doS3Upload(attachments, fileIds, 'company_registration')
       .then((res) => {
         res.forEach((ele) => {
           list.push(ele?.id?.toString());
         });
       }).catch();
   }
   return list;
 };

  callDropdown = (id) => {
    const { selectedDropdownId }= this.state;
    if (selectedDropdownId === id) {
      this.setState({ dropdown: false, selectedDropdownId: '' });
    } else {
      this.setState({ dropdown: true, selectedDropdownId: id });
    }
  };

  getRow = () => {
    const { answers } = this.state;
    const result = tableHeadders.map((ele) => {
      if (ele[1] === 'Attachments') {
        return (
          <div style={{ display: 'grid', gridTemplateColumns: '200%' }}>
            <span className={detailStyles.AttachmentTitle}>
              <FormattedMessage
                id="module.detail"
                defaultMessage="Attachments"
              />
            </span>
            {answers?.attachments?.length > 0 && (
            <div>
              <AttachmentDetail
                attachments={answers?.attachments}
              />
            </div>)}
          </div>
        );
      }
      return (
        <div className={detailStyles.infoRow}>
          <span className={detailStyles.title}>
            <FormattedMessage
              id="module.detail"
              defaultMessage={[ele[1]]}
            />
          </span>
          <span className={detailStyles.rowContent}>
            {ele[1].toLowerCase().includes('date')? renderInfoForType({ type: 'date' }, answers?.[ele[0]], result, true) : answers?.[ele[0]]}
          </span>
        </div>
      );
    });
    return result;
  };

  checkAllChecklistsSelected =(fieldId) => {
    const { answers, customFields } = this.state;
    const isRequired = customFields?.filter(each => each.id===fieldId)?.[0]?.required || false;
    let flag = false;
    if (isRequired && answers?.response?.[fieldId]) {
      const answered = Object.keys(answers?.response?.[fieldId]);
      let questions = customFields?.filter(each => each.id===fieldId)?.[0]?.schema?.fields || [];
      questions = questions?.filter(each => each.type==='inspection');
      if (answered.length === questions.length) {
        flag=answered.every((each) => {
          const qtnsChecklists = questions.filter(e => e.id=== each)?.[0]?.checklist?.length;
          if (Object.keys(answers?.response?.[fieldId][each]).length === qtnsChecklists) {
            return true;
          }
          return false;
        });
      }
    }
    if (flag || !isRequired) {
      this.handleFieldErrorChanged(fieldId, false);
    }
  }

  handleCheckListAnswer = (fieldId, checkLisId, subCheckListKey, pass, remarks) => {
    const { answers } = this.state;
    const useCheckObj = {
      [fieldId]: {
        ...answers?.response?.[fieldId],
        [checkLisId]: {
          ...answers?.response?.[fieldId]?.[checkLisId],
          [subCheckListKey]: {
            ...answers?.response?.[fieldId]?.[checkLisId]?.[subCheckListKey],
            check_lilst_status: pass,
            checklist_remarks_list: remarks
          }
        }
      }
    };
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        response: { ...answers.response, ...useCheckObj }
      }
    }), () => this.checkAllChecklistsSelected(fieldId));
  }

  handleLoader(loader) {
    this.setState({ loader });
  }

  handleValidation = (value) => {
    let isEmailValid = false;
    if (value?.length > 0) {
      const mail = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
        value
      );
      isEmailValid = mail;
      if (!mail) {
        this.setState({ error: 'Email is not valid' });
      }
    } else if (value === '' || value === undefined) {
      isEmailValid = true;
    }
    return isEmailValid;
  };

  render() {
    const { step, defaultFields, customFields, answers, phone, generateOtp, otpSent, otp, retrivedData, formErrors, dropdown,
      selectedDropdownId, airportLogo, formTitle, description, postSubmissionMsg, publicEnable, loader, error } = this.state;
    const htmlRef = React.createRef();
    return (
      <>
        <Loading loadingStatus={loader} />
        {!publicEnable
        && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
          <h4><FormattedMessage defaultMessage="You are not allowed to access this page." id="module.detail" /></h4>
        </div>
        )}
        {publicEnable
        && (
          <>
            <div style={{ maxHeight: '0px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingTop: '8%' }}
              className={styles.formDetail}
            >
              <img height={120} width={120} style={{ marginBottom: '10px' }} src={airportLogo} alt="logo" />
              <FormattedMessage
                id=" "
                defaultMessage={formTitle}
              />
              <div
                key="description"
                style={{ marginTop: '15px', lineHeight: '5px', textAlign: 'center' }}
                  // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                dangerouslySetInnerHTML={{ __html: eval('`' + description + '`') }}
              />
              <div style={{ display: 'none' }}>
                <div
                  ref={htmlRef}
                  key="description"
                    // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                  dangerouslySetInnerHTML={{ __html: eval('`' + description + '`') }}
                />
              </div>
            </div>
            <div className={`${(step!=='login') && `container ${styles.mainContainer}`}`}>
              <div className={`${styles.form} ${(step!=='edit'&& step!=='create' && step!=='view')? styles.flexCenter: ''}`}
                style={{ alignItems: `${step==='log' ? 'flex-start': 'center'}` }}
              >
                {(step==='create' || step==='edit') && (
                <div>
                  <h2>{step==='create' ? 'New' : 'Edit'}</h2>
                  <hr />
                  <CustomFields
                    handleAnswerChanged={(a, b) => this.handleAnswerChanged('answers', a, b)}
                    handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)}
                    showFormErrors={formErrors}
                    requiredMap={this.getRequired(defaultFields)}
                    fields={defaultFields}
                    answers={answers}
                    forQuestionMarkHelp
                  />
                  <CustomFields
                    handleAnswerChanged={(a, b) => this.handleAnswerChanged('response', a, b)}
                    handleFieldErrorChanged={(a, b) => this.handleFieldErrorChanged(a, b)}
                    showFormErrors={formErrors}
                    requiredMap={this.getRequired(customFields)}
                    fields={customFields}
                    answers={answers.response}
                    handleCheckListAnswer={this.handleCheckListAnswer}
                    handleUploadAttachments={this.handleUploadAttachments}
                    Company
                    forQuestionMarkHelp
                  />
                </div>
                )
          }
                {step==='login' && (
                <>
                  {generateOtp && (
                  <div className={loginStyles.login_form}>
                    <div className={loginStyles.login_form_wrapper}>
                      <div className={loginStyles.login_message} style={{ marginTop: '6%' }}>
                        <FormattedMessage
                          id="authentication.login.adp"
                          defaultMessage="Please, authorise with your phone number"
                        />
                      </div>
                      <p style={{ fontSize: '12px', margin: 0 }}>We’ll send a code in few mins</p>
                      <div className={loginStyles.column_wrapper}>
                        <div className={loginStyles.form_column}>
                          <label htmlFor="phone">
                            <ReactTelInput
                              type="text"
                              id="phone"
                              flagsImagePath={flags}
                              onChange={(e) => { this.handleInputChange('phone', e); }}
                              name="phone number"
                              required
                              value={phone}
                              classNames={loginStyles.telephoneInput}
                              defaultCountry={this.fetchLocation()||'us'}
                              placeholder="Phone Number"
                              inputProps={{ placeholder: 'Enter Phone Number' }}
                            />
                            <div className={loginStyles.circle_green} />
                          </label>
                        </div>
                      </div>
                      <div className={loginStyles.button_wrapper}>
                        <button
                          type="submit"
                          className={loginStyles.button}
                          onClick={() => this.handleSubmit(step)}
                        >
                          <FormattedMessage id="authentication.login.get_code" defaultMessage="Get Code" />
                        </button>
                      </div>
                    </div>
                  </div>
                  )}
                  {otpSent && (
                  <div className={loginStyles.login_form} style={{ height: '230px' }}>
                    <div className={loginStyles.login_form_wrapper}>
                      <div className={loginStyles.login_message} style={{ marginTop: '6%' }}>
                        <FormattedMessage id="authentication.login.otp" defaultMessage="Please enter code" />
                      </div>
                      <div className={loginStyles.form_column}>
                        <label htmlFor="email">
                          <OtpInput
                            isInputNum
                            containerStyle="otp-Outline"
                            value={otp}
                            onChange={e => this.handleInputChange('otp', e)}
                            numInputs={6}
                            isDisabled={false}
                            className={styles.input_btn_style}
                            inputStyle={styles.otp_input}
                          />
                        </label>
                      </div>
                      <div className={loginStyles.button_wrapper}>
                        <button
                          type="submit"
                          className={loginStyles.button}
                          onClick={() => this.handleSubmit(step)}
                        >
                          <FormattedMessage id="authentication.login.login" defaultMessage="Login" />
                        </button>
                      </div>
                    </div>
                  </div>
                  )}
                </>
                )
          }
                {step === 'view'
          && (
          <div className={detailStyles.requestInfo}>
            <div style={{ display: 'grid', gridTemplateColumns: '50% 50%', padding: '0px 20px' }}>
              {answers && this.getRow()}
              <br />
              {answers.response && (
                <div style={{ display: 'grid', gridTemplateColumns: '200%' }}>
                  <CustomFieldDetail
                    data={answers.response}
                    version={{ schema: { fields: customFields } }}
                    fields={customFields || []}
                  />
                </div>
              )}
            </div>
          </div>
          )}
                {step === 'log' && (
                <div className={styles.responseMargin}>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0px' }}>
                    <Button onClick={() => this.handleCreate()} translationID="new" className="mt-2 mb-2"
                      defaultText="New Application" action="secondary"
                    />
                  </div>
                  <table className={styles.table}>
                    <tr>
                      <th>Company Name</th>
                      <th>Email</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Phone</th>
                      <th>Remarks</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                    <tbody>
                      {retrivedData && retrivedData.map(each => (
                        <tr>
                          <td>{each.company_name}</td>
                          <td>{each.email}</td>
                          <td>{each.first_name}</td>
                          <td>{each.last_name}</td>
                          <td>{each.phone}</td>
                          <td>
                            {(status[each.status].title === 'Rejected' && each.meta_data?.reject_comment)
                      || (status[each.status].title === 'Send Back' &&each.meta_data?.send_back_comment)
                      || ((status[each.status].title === 'Approved' || status[each.status].title === 'Pending') && '')}
                          </td>
                          <td>
                            <span style={{ padding: '10px 20px',
                              whiteSpace: 'nowrap',
                              borderRadius: '30px',
                              background: `${status[each.status].background}`,
                              color: `${status[each.status].color}` }}
                            >
                              {status[each.status].title}
                            </span>
                          </td>
                          <td style={{ width: '78px' }} className={`${dropdown && selectedDropdownId === each?.uid && styles.dropdownContainer}`}>
                            <div
                              onClick={() => this.callDropdown(each.uid)}
                              onKeyDown={() => this.callDropdown(each.uid)}
                              role="button"
                              tabIndex="0"
                            >
                              <span className={styles.dot} />
                              <span className={styles.dot} />
                              <span className={styles.dot} />
                              {
                        dropdown && selectedDropdownId === each?.uid
                        && (
                        <ul
                          className={`${styles.dropdown} ${dropdown ? styles.open : ''
                          }`}
                        >
                          <li className={styles.item}>
                            <span
                              onClick={() => this.handleAction(each.uid, 'view')}
                              onKeyDown={() => this.handleAction(each.uid, 'view')}
                              role="button"
                              tabIndex="0"
                            >
                              <FormattedMessage
                                id="sms.meeting.view"
                                defaultMessage="View"
                              />
                            </span>
                          </li>
                          {each.status===12 &&(
                          <li className={styles.item}>
                            <span
                              onClick={() => this.handleAction(each.uid, 'edit')}
                              onKeyDown={() => this.handleAction(each.uid, 'edit')}
                              role="button"
                              tabIndex="0"
                            >
                              <FormattedMessage
                                id="sms.meeting.edit"
                                defaultMessage="Edit"
                              />
                            </span>
                          </li>
                          )}
                        </ul>
                        )
                            }
                            </div>
                          </td>
                        </tr>
                      ))
              }
                    </tbody>
                  </table>
                </div>
                )
          }
                {step==='success' && (
                <div style={{ minHeight: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <div
                    key="postSubmissionMessage"
              // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                    dangerouslySetInnerHTML={{ __html: eval('`' + postSubmissionMsg + '`') }}
                  />
                  <div style={{ display: 'none' }}>
                    <div
                      ref={htmlRef}
                      key="postSubmissionMessage"
                      style={{ marginLeft: '5px' }}
                // eslint-disable-next-line react/no-danger, no-eval, prefer-template
                      dangerouslySetInnerHTML={{ __html: eval('`' + postSubmissionMsg + '`') }}
                    />
                  </div>
                </div>
                )}
              </div>
              {(step==='create' || step==='edit' || step==='view' || step==='success')
              && (
              <div className={styles.footer}>
                <p style={{ color: 'red' }}>{error}</p>
                <div>
                  <Button onClick={() => this.handleBack()} translationID="back" className={`mt-2 mb-2 ${styles.button}`}
                    defaultText="Back" action="tertiary"
                  />
                  {(step !=='success' && step !== 'view') && (
                  <Button onClick={() => this.handleSubmit(step)} translationID="submit" className="mt-2 mb-2"
                    defaultText="Submit" action="secondary"
                  />
                  )}
                </div>
              </div>
              )
              }
            </div>
          </>
        )}
        <span className={styles.link}>
          <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer">
            Powered by Aerosimple
          </a>
        </span>
      </>
    );
  }
}

export default CompanyRegistration;
